import React, {FC, useEffect} from 'react';

import {Drawer} from '@optimaxdev/design-system';
import {Exit, Icon} from '@optimaxdev/icons';
import {connect} from 'react-redux';

import {ApplicationStoreType} from 'desktop/store';
import {logWithSentry} from 'libs/sentry/sentry';

import {setPopupLoading} from '../../store/reducers/orderLast/orderLast';
import {getTrustpilotQueryString} from '../../store/selectors/orderLast/orderLast';

import s from './drawerReview.scss';

const DrawerHeader = ({setIsDrawerOpen}: {setIsDrawerOpen?: (isOpen: boolean) => void}) => (
    <div className={s.header}>
        <Icon
            color="white"
            icon={Exit}
            label="Close drawer"
            onClick={() => setIsDrawerOpen && setIsDrawerOpen(false)}
        />
    </div>
);

export type PropsType = {
    setIsLoading: (isLoading: boolean) => void;
    trustpilotQueryString: string;
    isDrawerOpen?: boolean;
    setIsDrawerOpen?: (isOpen: boolean) => void;
};

/**
 * Trust Pilot layout for render popup
 */
export const DrawerReview: FC<PropsType> = ({
    isDrawerOpen,
    setIsDrawerOpen,
    setIsLoading,
    trustpilotQueryString,
}) => {
    useEffect(() => {
        setIsLoading(true);
        if (!trustpilotQueryString) {
            logWithSentry(
                new Error('No "trustpilotQueryString" was provided to trustPilot iframe'),
            );
        }
    }, [setIsLoading, trustpilotQueryString]);

    /**
     * On trust pilot frame load
     */
    const onLoad = () => setIsLoading(false);

    return (
        <Drawer
            customHeader={<DrawerHeader setIsDrawerOpen={setIsDrawerOpen} />}
            isOpened={Boolean(isDrawerOpen)}
            onClick={() => setIsDrawerOpen && setIsDrawerOpen(false)}
        >
            <iframe
                className={s.iframe}
                name="trustpilot"
                onLoad={onLoad}
                src={`https://www.trustpilot.com/evaluate/embed/www.glassesusa.com${trustpilotQueryString}`}
                title="trustpilot"
                width="375px"
            />
        </Drawer>
    );
};
const mapDispatchToProps = {
    setIsLoading: setPopupLoading,
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    trustpilotQueryString: getTrustpilotQueryString(store),
});
export const DrawerReviewConnected = connect(mapStateToProps, mapDispatchToProps)(DrawerReview);
